export const baseSecurityConfig = {
  prompt: 'login',
  acrValues: 'http://schemas.openid.net/pape/policies/2007/06/multi-factor', // renamed from acr_values
  responseType: 'code', // renamed from response_type
  scope: 'openid profile email offline_access', // renamed from scope
  disableSignup: true, // renamed from disable_signup
  certificateType: 'hard', // renamed from certificate_type
  maxAge: 7200, // renamed from max_age
  connectionScope: 'certificates', // renamed from connection_scope
};

export const defaultSecurityConfig = {
  domain: process.env.REACT_APP_AUTH0_DOMAIN,
  clientId: process.env.REACT_APP_AUTH0_CLIENT_ID,
  authorizationParams: {
    ...baseSecurityConfig,
    redirect_uri: window.location.origin,
    audience: process.env.REACT_APP_AUTH0_AUDIENCE,
  },
};
